var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEnvironmentCalendarInactive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 0.833496V2.50016H12.4993V0.833496H14.166V2.50016H17.4993C17.9596 2.50016 18.3327 2.87326 18.3327 3.3335V16.6668C18.3327 17.1271 17.9596 17.5002 17.4993 17.5002H2.49935C2.03912 17.5002 1.66602 17.1271 1.66602 16.6668V3.3335C1.66602 2.87326 2.03912 2.50016 2.49935 2.50016H5.83268V0.833496H7.49935ZM16.666 9.16683H3.33268V15.8335H16.666V9.16683ZM9.16602 10.8335V14.1668H4.99935V10.8335H9.16602ZM5.83268 4.16683H3.33268V7.50016H16.666V4.16683H14.166V5.8335H12.4993V4.16683H7.49935V5.8335H5.83268V4.16683Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnvironmentCalendarInactive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/EnvironmentCalendarInactive.409d9c48.svg";
export { ForwardRef as ReactComponent };